export const nlDic = {
    attributes: {
        component_id: 'Onderdeel',
        customer_id: 'Klant',
        component_type_id: 'Type',
        packet_number: 'Pakket',
        interval_control: 'Controle',
        packet_id: 'Pakket',
        weight_rate: 'Gewicht',
        back_pressure_rate: 'Tegendruk',
        leakage_rate: 'Leksnelheid',
        max_weight_rate: 'max. weight',
        min_weight_rate: 'min. weight',
        min_back_pressure_rate: 'min. back pressure',
        max_back_pressure_rate: 'max. back pressure',
        min_leakage_rate: 'min. leakage',
        max_leakage_rate: 'max. leakage'
    }
}
